/**
 * A workflow a member's app copied (Share with the organization, 2026-10-31),
 * read into the organization's draft: the pasted text, held to the organization
 * workflows' validator, replacing the one of its name or added after the rest.
 * The list as it would be, or the sentence that refuses the paste.
 */
import { MAX_WORKFLOWS } from '@airlock/contracts/workflow/sanitize';
import { parseOrgWorkflows } from '@airlock/contracts/workspace/parse';
import type { DocWorkflow } from '../../../lib/types';

export function importedWorkflows(
  workflows: DocWorkflow[],
  pasted: string,
  newId: () => string
): { workflows: DocWorkflow[]; id: string } | string {
  let read: unknown;
  try {
    read = JSON.parse(pasted);
  } catch {
    return 'That is not what Airlock copied — in the app, Share with the organization copies a workflow.';
  }
  const body = read && typeof read === 'object' && !Array.isArray(read) ? (read as Record<string, unknown>) : {};
  const same = workflows.find((one) => one.name === body.name);
  if (!same && workflows.length >= MAX_WORKFLOWS) return `An organization keeps at most ${MAX_WORKFLOWS} workflows.`;
  const parsed = parseOrgWorkflows({
    workflows: [
      {
        id: same?.id ?? newId(),
        name: body.name,
        steps: body.steps ?? [],
        edges: body.edges ?? [],
        sortOrder: same?.sortOrder ?? workflows.length
      }
    ]
  });
  if (!parsed.ok) return parsed.problems.slice(0, 2).join(' · ');
  const [made] = parsed.document.workflows;
  return {
    workflows: same ? workflows.map((one) => (one.id === same.id ? made : one)) : [...workflows, made],
    id: made.id
  };
}
